import GameControlButton from "@/Components/GameControlButton"
import { useFullscreen } from "@/Hooks/useFullscreen"
import { addToastNotification } from "@/store/globalSlice"
import { useAppDispatch } from "@/store/hooks"
import classNames from "classnames"
import { useState } from "react"

interface FullscreenToggleProps {
  className?: string
  testId?: TestId
}

const FullscreenToggle: React.FC<FullscreenToggleProps> = ({ className, testId = "fullscreen-toggle" }) => {
  const { isFullscreen, supported, toggle } = useFullscreen()
  const dispatch = useAppDispatch()
  // Once a click has proven the browser won't give the screen back, the tooltip
  // stops promising something the button cannot deliver.
  const [exitNeedsF11, setExitNeedsF11] = useState(false)

  if (!supported) return null

  const label = isFullscreen ? (exitNeedsF11 ? "Press F11 to exit full screen" : "Exit full screen") : "Full screen"

  const handleClick = async () => {
    const { blocked } = await toggle()
    setExitNeedsF11(blocked)
    if (!blocked) return
    dispatch(
      addToastNotification({
        type: "general",
        message: "Press F11 to leave full screen — the browser started it, so the game can't end it.",
        messageType: "info",
      })
    )
  }

  return (
    <GameControlButton
      accent="emerald"
      onClick={handleClick}
      data-testid={testId}
      aria-label={label}
      title={label}
      className={classNames("!px-0 !py-0", className)}
    >
      <span className="relative flex h-full w-full items-center justify-center">
        <i className={classNames("fa-solid fa-lg mobile:!text-[13px]", isFullscreen ? "fa-compress" : "fa-expand")}></i>
      </span>
    </GameControlButton>
  )
}

export default FullscreenToggle
